import { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Fallback shown instantly while the fetch resolves (keeps LCP/layout stable).
const FALLBACK = {
  rating: 4.9,
  user_ratings_total: 120,
  reviews: [],
  source: "fallback-init",
};

// Simple module-level cache — avoids hitting /api/google-reviews multiple times
// when several components mount together (Hero + Testimonials + Chrono hero).
let _sharedCache = null;
let _sharedPromise = null;

async function loadReviews() {
  if (_sharedCache) return _sharedCache;
  if (_sharedPromise) return _sharedPromise;
  _sharedPromise = fetch(`${BACKEND_URL}/api/google-reviews`)
    .then((r) => (r.ok ? r.json() : FALLBACK))
    .then((d) => {
      _sharedCache = d && typeof d.rating === "number" ? d : FALLBACK;
      return _sharedCache;
    })
    .catch(() => {
      _sharedCache = FALLBACK;
      return FALLBACK;
    });
  return _sharedPromise;
}

/**
 * Live Google reviews hook. Returns:
 *   { rating, user_ratings_total, reviews, loading }
 * `reviews` only contains 5-star reviews (backend-filtered).
 * Safe on SSR — returns fallback instantly, updates after mount.
 */
export function useGoogleReviews() {
  const [data, setData] = useState(_sharedCache || FALLBACK);
  const [loading, setLoading] = useState(!_sharedCache);

  useEffect(() => {
    let active = true;
    loadReviews().then((d) => {
      if (active) {
        setData(d);
        setLoading(false);
      }
    });
    return () => { active = false; };
  }, []);

  return { ...data, loading };
}
